<template>
    <div class="Trainee-TS-modal-overlay">
      <div class="Trainee-TS-modal-dialog" @click.stop>
        <div class="Trainee-TS-modal-content">
          <div class="Trainee-TS-modal-header">
            <h5 class="Trainee-TS-modal-title" style="padding-top: 10px;">Task ID: {{ taskId }}</h5>
          </div>
          <div class="container-fluid" v-show="currentTab === 'troubleshoot'">
            <div class="artificial-fieldset">
              <label class="artificial-fieldset-legend">Revoke Signoff</label>
              <div class="question">
                <table class="trainee-info-table">
                  <tr>
                    <th>Please provide a reason to revoke this SignOff</th>
                  </tr>
                </table>
              </div>
            </div>
            <div class="trainee-answer-section">
              <div class="artificial-fieldset">
                <div ref="editor" class="quill-editor" :class="{ 'read-only': readOnly }"></div>
              </div>
            </div>
            <div class="Trainee-modal-footer">
              <button @click="close" class="btn btn-secondary">Close</button>
              <div class="right">
                <button @click="submitAnswers" class="btn btn-primary" style="background-color: brown;">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import Quill from 'quill';
  import 'quill/dist/quill.snow.css';
  
  export default {
    name: 'revokeSignOffModal',
    props: {
      taskId: {
        type: [String, Number],
        required: true,
      },
      logbookId: {
        type: [String, Number],
        required: true,
      },
      revokeReason: String,
    },
    data() {
      return {
        currentQuestionIndex: 0,
        questions: [
          'L/H Wind Anti-Ice Caution on EICAS. System switch to stand by mode, message still present',
          'Gen l off caution message on EICASS. Reset Unsuccessfull',
          'Yaw damper 1 Disengage at time. Reengagement possible',
        ],
        showRevokeModal: true,
        editableRevoke: this.revoke_reasoning,
        currentTab: 'troubleshoot',
        quill: null,
      };
    },
    computed: {
      currentQuestion() {
        return this.questions[this.currentQuestionIndex];
      },
      QuestionsCount() {
        return this.questions.length;
      },
    },
    watch: {
      showRevokeModal(newValue) {
        if (newValue && this.quill) {
          // Wait for the next tick to ensure the Quill editor is mounted and visible
          this.$nextTick(() => {
            this.quill.root.innerHTML = this.editableRevoke || '';
          });
        }
      },
      editableRevoke(newVal) {
        if (newVal !== this.quill.root.innerHTML) {
          this.quill.root.innerHTML = newVal;
        }
      },
      currentTab(newVal, oldVal) {
        if (newVal === 'troubleshoot' && oldVal === 'description') {
          this.initializeQuillEditor();
        }
      },
    },
    mounted() {
      this.initializeQuillEditor();
      this.loadAnswers();
    },
    methods: {
      initializeQuillEditor() {
        if (!this.quill) {
          this.quill = new Quill(this.$refs.editor, {
            theme: 'snow',
            modules: {
              toolbar: [],
            },
          });
  
          this.quill.on('text-change', () => {
            this.editableRevoke = this.quill.root.innerHTML;
          });
  
          this.quill.root.innerHTML = this.editableRevoke || '';
          this.adjustEditorHeight();
        }
      },
      loadAnswers() {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };
  
        axios
          .get(`/api/logbookentry/${this.logbookId}/${this.taskId}`, { headers })
          .then((response) => {
            const storedAnswer = response.data.task.revoke_reasoning; // Adjust based on your API response structure
            console.log(response.data.task.revoke_reasoning);
            this.editableRevoke = storedAnswer;
            this.is_revoked = response.data.task.is_revoked;
            console.log(this.is_revoked);
  
            // After loading the answer, update the Quill editor content
            if (this.quill) {
              this.quill.root.innerHTML = storedAnswer || '';
            }
            if (this.is_revoked === 1) {
              this.makeEditorReadOnly(); // Apply the read-only state if needed
            }
          })
          .catch((error) => {
            console.error('Failed to load answers', error);
            // Handle the error, show a message, etc.
          });
      },
      adjustEditorHeight() {
        const editorElement = this.$refs.editor.querySelector('.ql-editor');
        const toolbar = this.$refs.editor.querySelector('.ql-toolbar');
        const toolbarButtons = this.$refs.editor.querySelectorAll('.ql-toolbar .ql-formats');
  
        if (editorElement) {
          editorElement.style.height = '260px';
          editorElement.style.fontFamily = 'monospace';
        }
        if (toolbar) {
          toolbar.style.height = '40px';
          toolbar.style.minHeight = '30px';
        }
        if (toolbarButtons) {
          toolbarButtons.forEach((btnGroup) => {
            btnGroup.style.margin = '0 2px';
          });
        }
      },
      close() {
        this.$emit('close');
      },
      saveAnswers() {
        this.saveOrUpdateAnswers(false);
      },
      submitAnswers() {
        if (window.confirm('Once you submit, you cannot edit the answers. Are you sure you want to continue?')) {
          this.saveOrUpdateAnswers(true);
        }
      },
      saveOrUpdateAnswers(isSubmitting) {
        const formattedRevoke = this.quill.root.innerHTML;
        const url = `/api/logbookentry/${this.logbookId}/${this.taskId}`;
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };
  
        // Prepare the data to be sent in the request
        const requestData = {
          completed: null,
          ins_so: null,
          revoke_reasoning: formattedRevoke
        };
  
        // If submitting, include the is_revoked value in the request data
        if (isSubmitting) {
          requestData.is_revoked = true;
        }
  
        axios
          .put(url, requestData, { headers })
          .then((response) => {
            console.log(response.data);
            alert('Trainee Signoff revoked successfully.');
  
            if (isSubmitting) {
              this.makeEditorReadOnly();
            }
          })
          .catch((error) => {
            console.error('There was an error!', error);
            alert('Failed to save the answer.');
          });
      },
        makeEditorReadOnly() {
            if (this.quill) {
                this.quill.enable(false); // This disables editing
                this.quill.getModule('toolbar').container.style.display = 'none'; // This hides the toolbar
            }
            this.$emit('close');
        },

        prevQuestion() {
            if (this.currentQuestionIndex > 0) {
                this.currentQuestionIndex--;
                // The computed property 'currentQuestion' will automatically update the question displayed
            }

        },
        nextQuestion() {
            if (this.currentQuestionIndex < this.questions.length - 1) {
                this.currentQuestionIndex++;
            }
        }
    }
}


</script>
 


<style scoped>
table.trainee-info-table {
    font-family: Arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
    margin-top: 10px;
}

.trainee-info-table th, 
.trainee-info-table td {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 6px;
    font-size: 14px;
}

.trainee-info-table td {
    font-weight: 100;
}

.trainee-info-table th {
    background-color: #f2f2f2;
}

.Trainee-TS-modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(97, 94, 94, 0.5);
    z-index: 1000;
    JUSTIFY-CONTENT: CENTER;
}

.Trainee-TS-modal-body h2 {
    list-style-type: none;
    margin-top: 10px;
    padding: 0;
    margin-right: 1%;
    text-align: center;

}

.Trainee-TS-modal-body ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    text-align: left;
    margin-left: 5%;
}

.Trainee-TS-modal-body p.heading {
    list-style-type: none;
    margin-top: 20px;
    text-align: left;
    margin-left: 1%;
}

.assessment-criteria-box {
    border: 1px solid #b1b1b1;
    /* You can adjust the border color and thickness */
    padding: 10px;
    /* Optional: Add padding for better appearance */
    margin: 10px 0;
    /* Optional: Add margin for spacing */
}


.Trainee-TS-modal-content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 1000px;
    width: 100%;
    margin: auto;
    padding: 0;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.Troubleshoot-modal-dialog {
    display: flex;
    flex-direction: row;
    /* Arrange children (questions and answers) in a row */
}

.Trainee-TS-modal-dialog {
    max-height: 90vh;
    overflow-y: auto;
}

.Troubleshoot-modal-body {
    display: flex;

}

.question-item {
    margin: 10px 0;
    text-align: left;
    font-weight: bold;
}

.Trainee-questions-container>ol>li>ul {
    list-style-type: disc;
    /* Adds a bullet point (dot) */
    padding-left: 40px;
    /* Indent subpoints further than the main list */
}

.Trainee-questions-container ul li {
    margin: 5px 0;
}

.Trainee-questions-container {
    text-align: left;
}

button {
    /* Adjust as needed */
    width: 100px;
    /* Adjust as needed */
    padding: 10px;
    /* Adjust as needed */
    background-color: #f2f2f2;
    /* Style as needed */
    border: none;
    /* Style as needed */
    cursor: pointer;
    /* Style as needed */
    /* Add more styling as needed */
}

.questions-list {
    text-align: left;
}

.Trainee-questions-container h6,
.Trainee-answers-container h6 {
    width: 100%;
    background-color: rgb(216, 216, 216);
    /* Light grey background */
    /* Border for the header */
    text-align: center;

}


.list-group-item {
    background-color: transparent;
    /* Remove default background */
}

.list-group-numbered {
    counter-reset: list-group-counter;
    text-align: left;
}

.list-group-numbered>.list-group-item:before {
    content: counter(list-group-counter) ". ";
    counter-increment: list-group-counter;
}

/* Style for the nested ul */
.Trainee-questions-container ul {
    list-style-type: none;
    /* Removes bullet points */
    padding-left: 20px;
    /* Indent subpoints */
}

.Trainee-answers-container {
    outline: none;
    z-index: 1000;
    width: 60%;
}

.Trainee-modal-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.Trainee-modal-footer .right {
    margin-top: 1%;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    /* Adjust the gap between buttons */
}

.nav-link {
    cursor: pointer;
}

.artificial-fieldset {
    border: 1px solid #ddd;
    padding: 10px;
    margin-top: 20px;
    position: relative;
}

.artificial-fieldset-legend {
    position: absolute;
    top: -10px;
    left: 10px;
    background-color: #fff;
    padding: 0 10px;
    font-weight: bold;
}


.question {
    text-align: left;
    font-weight: bold;
}

.navigation-buttons {
    margin-top: 5px;
}

.nav-button {
    padding: 5px 15px;
    /* Adjust padding to change button size */
    margin: 0 5px;
    /* Space between buttons */

}


.ql-toolbar {
    height: 40px;
    min-height: 40px;
}


.ql-toolbar .ql-formats {
    margin: 0 2px;
}

.ql-container .ql-editor {
    height: 200px;
    min-height: 200px;
}

h4 {
    font-size: 1.5rem;
    margin-top: 30px;
    margin-bottom: 30px;
}</style>